import { CreateAgendaBlockRequest, EditAgendaBlockRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { AgendaBlockResponse, HisAgendaBlockResponse } from "@shared/dtos/responses/appointmentResponses.dto"
import { AgendaBlockCreationResponse } from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const hisBlockNames = (practiceId: string): Promise<HisAgendaBlockResponse[]> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendablocks/hisblocknames`,
    method: "get",
  }).then((resp) => resp.data)
}

export const getAll = (practiceId: string): Promise<AgendaBlockResponse[]> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendablocks`,
    method: "get",
  }).then((resp) => resp.data)
}

export const create = (practiceId: string, req: CreateAgendaBlockRequest): Promise<AgendaBlockCreationResponse> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendablocks`,
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}

export const edit = (practiceId: string, agendaBlockId: string, req: EditAgendaBlockRequest): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/agendablocks/${agendaBlockId}`,
    method: "patch",
    data: req,
  }).then(() => undefined)
}

export const remove = (practiceId: string, agendaBlockId: string): Promise<void> => {
  return axiosAuth({
    url: `practices/${practiceId}/agendablocks/${agendaBlockId}`,
    method: "delete",
  }).then(() => undefined)
}
